// Moglee Base — close the mobile menu when tapping outside it.
//
// The dimmed overlay is not a reliable tap target on iOS, so this listens for
// any pointer down outside the panel while the menu is open. It only runs when
// the menu is open, so it can never interfere with taps elsewhere.

(function () {
  var root = document.documentElement;

  function isOpen() {
    return root.getAttribute('data-mb-menu-open') === 'true';
  }

  function close() {
    var menu = document.querySelector('[data-mb-menu]');
    var button = document.querySelector('[data-mb-menu-button]');

    root.removeAttribute('data-mb-menu-open');
    document.body.style.overflow = '';
    if (menu) menu.setAttribute('aria-hidden', 'true');
    if (button) button.setAttribute('aria-expanded', 'false');
  }

  function handle(event) {
    if (!isOpen()) return;

    var target = event.target;
    if (target.closest && target.closest('[data-mb-menu]')) return;
    if (target.closest && target.closest('[data-mb-menu-button]')) return;

    close();
  }

  // pointerdown covers mouse and touch; touchstart is the fallback for older iOS.
  document.addEventListener('pointerdown', handle, true);
  document.addEventListener('touchstart', handle, true);
  document.addEventListener('click', handle, true);
})();
